import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import React, { useMemo } from 'react';
import lodash from 'lodash';
import serviceData from 'configs/survey_service.json';

interface IServicePackage {
    service: object;
}

const SurveyService: React.FC = () => {
    const [data] = React.useState<IServicePackage>({
        service: serviceData,
    });

    const serviceThreshold = useMemo(() => {
        return lodash.get(data, 'service.service_threshold', {});
    }, [data]);
    const basePrice = useMemo(() => {
        return lodash.get(data, 'service.base_prices', {});
    }, [data]);
    const targetPrice = useMemo(() => {
        return lodash.get(data, 'service.target_prices', {});
    }, [data]);

    return (
        <Box mt={3}>
            <TableContainer
                component={Paper}
                sx={{
                    boxShadow: 'none',
                    border: 'none',
                }}
            >
                <Table sx={{ borderCollapse: 'collapse' }}>
                    <TableHead
                        sx={{
                            backgroundColor: 'var(--color-primary-lighter)',
                        }}
                    >
                        {['STT', 'Bảng câu hỏi'].map((item, index) => (
                            <TableCell
                                key={`static-header-static-${index}`}
                                align={'left'}
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {item}
                            </TableCell>
                        ))}
                        {Object.keys(serviceThreshold).map((item, index) => (
                            <TableCell
                                key={`static-header-${index}`}
                                align={'left'}
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {lodash.get(serviceThreshold, `${item}.text`)}
                            </TableCell>
                        ))}
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            />
                            <TableCell
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {lodash.get(basePrice, 'label')}
                                <Typography component={'p'}>
                                    {lodash.get(basePrice, 'sub_label')}
                                </Typography>
                            </TableCell>
                            {Object.keys(
                                lodash.get(basePrice, 'children', {})
                            ).map((item) => {
                                return (
                                    <TableCell
                                        key={`base-price-children-${item}`}
                                        sx={{
                                            border: 'none',
                                            fontSize: '18px',
                                            lineHeight: '21.78px',
                                        }}
                                    >
                                        {lodash.get(
                                            basePrice,
                                            `children.${item}.text`
                                        )}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            />
                            <TableCell
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {lodash.get(targetPrice, 'label')}
                                <Typography component={'p'}>
                                    {lodash.get(targetPrice, 'sub_label')}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        {Object.keys(
                            lodash.get(targetPrice, 'children', {})
                        ).map((firstItem) => {
                            const itemDetail = lodash.get(
                                targetPrice,
                                `children.${firstItem}.target_detail`,
                                {}
                            );
                            const itemChild = lodash.get(
                                targetPrice,
                                `children.${firstItem}.children`,
                                {}
                            );
                            return (
                                <>
                                    <TableRow
                                        key={`target-price-children-${firstItem}`}
                                    >
                                        <TableCell
                                            sx={{
                                                border: 'none',
                                                fontWeight: 600,
                                                fontSize: '18px',
                                                lineHeight: '21.78px',
                                            }}
                                        >
                                            {firstItem}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                border: 'none',
                                                fontWeight: 600,
                                                fontSize: '18px',
                                                lineHeight: '21.78px',
                                            }}
                                        >
                                            {lodash.get(
                                                targetPrice,
                                                `children.${firstItem}.label`,
                                                ''
                                            )}
                                        </TableCell>
                                        {Object.keys(itemDetail).map(
                                            (secondItem) => {
                                                return (
                                                    <TableCell
                                                        key={`target-price-children-${firstItem}-target_detail-${secondItem}`}
                                                        sx={{
                                                            border: 'none',
                                                            fontSize: '18px',
                                                            lineHeight:
                                                                '21.78px',
                                                        }}
                                                    >
                                                        {lodash.get(
                                                            itemDetail,
                                                            `${secondItem}.text`
                                                        )}
                                                    </TableCell>
                                                );
                                            }
                                        )}
                                    </TableRow>
                                    {Object.keys(itemChild).map(
                                        (thirdItem: string) => {
                                            const thirdItemDetail = lodash.get(
                                                itemChild[
                                                    thirdItem as keyof typeof itemChild
                                                ],
                                                `target_detail`,
                                                {}
                                            );
                                            return (
                                                <TableRow
                                                    key={`target-price-children-${firstItem}-children-${thirdItem}`}
                                                >
                                                    <TableCell
                                                        sx={{
                                                            border: 'none',
                                                            fontWeight: 600,
                                                            fontSize: '18px',
                                                            lineHeight:
                                                                '21.78px',
                                                        }}
                                                    >
                                                        {thirdItem}
                                                    </TableCell>
                                                    <TableCell
                                                        sx={{
                                                            border: 'none',
                                                            fontSize: '18px',
                                                            lineHeight:
                                                                '21.78px',
                                                        }}
                                                    >
                                                        {lodash.get(
                                                            itemChild[
                                                                thirdItem as keyof typeof itemChild
                                                            ],
                                                            `label`,
                                                            ''
                                                        )}
                                                    </TableCell>
                                                    {Object.keys(
                                                        thirdItemDetail
                                                    ).map((fourthItem) => {
                                                        return (
                                                            <TableCell
                                                                key={`target-price-children-${firstItem}-children-${thirdItem}-target_detail-${fourthItem}`}
                                                                sx={{
                                                                    border: 'none',
                                                                    fontSize:
                                                                        '18px',
                                                                    lineHeight:
                                                                        '21.78px',
                                                                }}
                                                            >
                                                                {lodash.get(
                                                                    thirdItemDetail,
                                                                    `${fourthItem}.text`
                                                                )}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        }
                                    )}
                                </>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default SurveyService;
